import React, { useState, useEffect } from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

const Carousel = () => {

    const altText = [];
    const dataImg = [];

    const [nbrOfSlides, setnbrOfSlides] = useState(3.3)

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width >= 992) {
                setnbrOfSlides(3.5)
            } else if (width >= 768) {
                setnbrOfSlides(2.5)
            } else if (width > 475) {
                setnbrOfSlides(2)
            } else {
                setnbrOfSlides(1.5)
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [])


    for (let i = 1; i <= 13; i++) {
        altText.push(
            {
                txt: `Manicure faux ongles à motif français ${i} design à motifs bloc de couleur ${i}`,
                nbr: i
            }
        )
    }

    altText.map( info => {
        dataImg.push(
            {
                name : `ongles${info.nbr}`,
                src : `./img/work/ongles${info.nbr}.webp`,
                alt: info.txt,
                nbr : info.nbr
            }
        )
    });

  return (
    <Swiper
        slidesPerView = {nbrOfSlides}
        spaceBetween = {30}
    >
        {dataImg.map( img => {
            if(img.src !== undefined) {
                return (
                    <SwiperSlide key={img.nbr}> 
                        <div className='imgContainer'>
                            <img src={img.src} alt={img.alt} />
                        </div>
                    </SwiperSlide>
                )
            }
        })}
    </Swiper>
  )
}

export default Carousel
